import Animation from './Animation';
import { play } from '../../../SoundManager';

export default class Slots extends Animation {

	constructor (master, slots) {

		super(master, 2000, true);
		this.slots = slots;
	}

	slotToImage (slot) {

		switch (slot) {
        case "berry": return "/images/berry.png"
        case "seed": return "/images/seed.png"
        case "coin": return "/images/coin.png"
        case "insight": return "/images/insight.png"
        case "potion": return "/images/randompotion.png"
        case "runes": return "/images/rune.png"
        case "shards": return "/images/shard.png"
        case "relic": return "/images/relic2.png"
        case "remove": return "/images/remove.png"
        default: return ""
        }
	}

	run () {

		var hideSlot = no => {

			var el = document.querySelector("#shop-slot-" + no + " img");
			if (el) {
				el.classList.add("invisible");
			}
		}

		hideSlot(0);
		hideSlot(1);
		hideSlot(2);

		var runSlot = no => {

			play("ding", 'sfx', 'scene');
			var el = document.querySelector("#shop-slot-" + no + " img");
			if (el) {
				el.classList.remove("invisible");
				el.src = this.slotToImage(this.slots[no]);
			}
		}

		setTimeout(() => runSlot(0), this.time/4);
		setTimeout(() => runSlot(1), this.time/4*2);
		setTimeout(() => runSlot(2), this.time/4*3);
	}
}
